import BaseJSNode from './BaseJSNode.js';
export default class ContinueStatement extends BaseJSNode {
    run() {
        return 'continue';
    }
}
